import { FC, useCallback, useState } from 'react';

import { maybeCall } from 'src/utils/common';
import { ModalContext } from './context';
import { ModalParams } from './types';

export const ModalProvider: FC = ({ children }) => {
  const [modalParams, setModalParams] = useState<ModalParams>(
    {} as ModalParams,
  );
  const [isModalOpen, setModalOpen] = useState(false);

  const onCloseModal = useCallback(() => {
    setModalOpen(false);
    maybeCall(modalParams?.onClose);
    setModalParams({} as ModalParams);
  }, [modalParams]);

  const onOpenModal = useCallback((modalParams: ModalParams) => {
    setModalParams(modalParams);
    setModalOpen(true);
  }, []);

  return (
    <ModalContext.Provider
      value={{
        modalParams,
        isModalOpen,
        onCloseModal,
        onOpenModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
